import { Component, OnInit } from '@angular/core';
import { CountriesService } from '../../../../../../services/countries.service';
import { LookupScreenService } from '../../../../../../services/lookup-screen.service';
import { Title } from '@angular/platform-browser';
import {
    AppointmentHistory,
    CosnultationHistoryDataQuery
} from 'src/app/models/appointment';
import { AppointmentService } from 'src/app/services/appointment.service';
import {
    PromiseResult
} from '../../../../../../models/PromiseResult';

import { LazyLoadEvent, MessageService } from 'primeng/api';
import { DoctorBreadcrumbService } from '../../../../shared/breadcrumb.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { PaginationModel } from '../../../../../../models/util.models';
import { async } from 'rxjs/internal/scheduler/async';
import { ProviderStateService } from 'src/app/services/provider-state.service';

interface pupdate {
    patient_guid: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    e_email: string;
    relation: string;
    address_line_1: string;
    address_line_2: string;
    date_of_birth: string;
    city: string;
    state_name: string;
    zip_code: string;
    state_id: string;
    country_name: string;
    country_id: string;
    primary_contact_number: string;
    secondary_contact_number: string;
    gender: string;
    phone_code?: string;
    valid?: string;
}

@TraceClassDecorator()
@Component({
    selector: 'app-lookup-display-p',
    templateUrl: './lookup-display-p.component.html',
    styleUrls: [
        './lookup-display-p.component.css',
        '../../../../../../../assets/css/custom-egd.css'
    ]
})
export class LookupDisplayPComponent implements OnInit {
    openDialog: boolean;
    disabled = true;
    patient;
    lookupDisplay = null;
    data = false;
    data2 = false;
    TranactionDetails = [];
    ConsltationDetails = [];
    List = [];
    view = false;
    message: string[];
    cols1 = [];
    cols2 = [];
    patient1: pupdate;
    countries: any[];
    states: any[];
    selectedCountry = null;
    selectedState = null;
    code: any;
    should_display_transaction_table = false;
    consultaionerror: PromiseResult;
    transactionerror: PromiseResult;

    loading1: boolean = false;
    loading: boolean = false;
    history_posting: boolean = false;
    historyDialog: boolean = false;
    history_response;
    history_serverError;
    history: AppointmentHistory;
    query: PaginationModel;
    total_records: number = 0;
    page_list = [10, 25, 50];
    provider_id: string = "";
    p_guid = null;
    slug: string = "";
    constructor(
        private readonly lookupservice: LookupScreenService,
        private readonly appointmentService: AppointmentService,
        private readonly CountryService: CountriesService,
        private readonly messageService: MessageService,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly router: Router,
        private readonly titleService: Title,
        private route: ActivatedRoute,
        private readonly providerStateService: ProviderStateService
    ) {

        this.query = {
            page_no: 1,
            records_per_page: this.page_list[0]
        }
    }

    async ngOnInit(): Promise<void> {
        this.titleService.setTitle('Dashboard - Patient Lookup Display');
        this.slug = this.providerStateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Lookup Screen' },
            { label: 'Lookup Patients Search' },
            { label: 'Patients List' },
            { label: 'Patients Details' }
        ]);
        this.provider_id = this.providerStateService.getProviderId();
        //   this.patient = this.lookupservice.getSelectedPatient();

        this.route.queryParamMap.subscribe(async (res) => {
            this.p_guid = res.get('p_guid');
        });


        this.getPatientDetails(this.p_guid);



        this.cols1 = [
            { field: 'transaction_no', header: 'Transaction no' },
            { field: 'status', header: 'Status' },
            //    { field: 'p_priority.priority_type', header: 'Priority Type' },
            { field: 'amount', header: 'Amount' },
            { field: 'currency_type', header: 'Currency Type' },
            { field: 'created_at', header: 'Created On' },
            {
                field: 'p_priority.consultation_name',
                header: 'Consultation Name'
            }
        ];

        this.cols2 = [
            { field: 'id', header: 'History' },
            {
                field: 'consultation_request_number',
                header: 'Consultation Request Number'
            },
            {
                field: 'p_consultation_appointment.doc',
                header: 'Doctor Name'
            },
            { field: 'p_consultation_appointment', header: 'Specialty Name' },
            { field: 'consultation_status', header: 'Consultation Status' },
            {
                field: 'consultation_type.consultation_name',
                header: 'Consultation Name'
            },
            //   {field: 'consultation_date', header: 'Consultation Date' },
            //  { field: 'p_transactions.razor_transaction_id', header: 'Razor Transaction Id'},
            //  { field: 'communication_type.communication_name', header: 'Communication Type'},
            //   { field: 'created_at', header: 'Created On'},
            //   { field: 'doctor_profile', header: 'Doctor Profile'},
            //   { field: 'followup_consultation_id', header: 'Followup Consultation Id'},
            //   { field: 'priority_type.priority_type', header: 'Priority Type'},
        ];
    }


    async getPatientDetails(p_guid) {
        await this.lookupservice.getPatientDetails(p_guid, '0').then(
            res => {
                if (res.success) {
                    // const p = {
                    //     patient_guid: this.p_guid,
                    //     first_name: res.data.first_name,
                    //     middle_name: res.data.middle_name,
                    //     last_name: res.data.last_name,
                    //     date_of_birth: res.data.date_of_birth,
                    //     address_line_1:res.data.address_line_1 || '',
                    //     address_line_2:res.data.address_line_2 || '',
                    //     zip_code: res.data.zip_code || '',
                    //     city: res.data.city || '',
                    //     state_name: res.data.state_name,
                    //     state_id: res.data.state_id.toString(),
                    //     country_name: res.data.country.country_name,
                    //     country_id: '',
                    //     primary_contact_number: res.data.primary_contact_number
                    //         .toString(),
                    //     secondary_contact_number: res.data.secondary_contact_number
                    //         ?.toString(),
                    //     phone_code: '',
                    //     gender: res.data.gender || '',
                    //     valid: res.data.valid_till.toString().substring(0, 10),
                    //     e_email :res.data.user_patient.users.e_email
                    // };

                    const p = {
                        patient_guid: this.p_guid,
                        first_name: res.data.first_name,
                        middle_name: res.data.middle_name,
                        last_name: res.data.last_name,
                        date_of_birth: res.data.date_of_birth,
                        address_line_1: res.data.address_line_1 || '',
                        address_line_2: res.data.address_line_2 || '',
                        zip_code: res.data.zip_code || '',
                        city: res.data.city || '',
                        state_name: res.data.state_name,
                        state_id: res.data.state_id.toString(),
                        country_name: res.data.country.country_name,
                        country_id: res.data.country_id.toString(),
                        primary_contact_number: res.data.primary_contact_number
                            .toString()
                            .replace('+' + res.data.country.phone_code.toString(), ''),
                        secondary_contact_number: res.data.secondary_contact_number
                            ?.toString()
                            .replace('+' + res.data.country.phone_code.toString(), '') || '',
                        phone_code: res.data.country.phone_code,
                        gender: res.data.gender || '',
                        valid: res.data.valid_till,
                        account_status: res.data.account_status,
                        medical_record_number: res.data.medical_record_number,
                        e_email: res.data.user_patient.users.e_email,
                        relation: res.data.relation
                    };


                    this.patient = p;
                    this.patient1 = {
                        patient_guid: this.patient?.patient_guid,
                        first_name: this.patient.first_name,
                        middle_name: this.patient.middle_name,
                        last_name: this.patient.last_name,
                        e_email: this.patient.e_email,
                        relation: this.patient.relation,
                        date_of_birth: this.patient.date_of_birth,
                        address_line_1: this.patient.address_line_1 || '',
                        address_line_2: this.patient.address_line_2 || '',
                        zip_code: this.patient.zip_code || '',
                        city: this.patient.city || '',
                        state_name: this.patient.state_name,
                        state_id: this.patient.state_id.toString(),
                        country_name: this.patient.country_name,
                        country_id: this.patient.country_id.toString(),
                        primary_contact_number: this.patient.primary_contact_number
                            .toString()
                            .replace('+' + this.patient.phone_code.toString(), ''),
                        secondary_contact_number: this.patient.secondary_contact_number
                            ?.toString()
                            .replace('+' + this.patient.phone_code.toString(), '') || '',
                        phone_code: this.patient.phone_code,
                        gender: this.patient.gender || '',
                        valid: this.patient.valid.toString().substring(0, 10),
                    };
                } else {
                    console.log("error");
                }

            }

        )
    }

    open1() {
        this.data = true;
        this.getCountries();
        this.setState((this.code = this.patient1.country_id));
    }

    async fetchTransactions(event: LazyLoadEvent) {
        if (event) {
            this.query.page_no = event.first / event.rows + 1;
            this.query.records_per_page = event.rows;
        }
        this.loading1 = true;
        this.TranactionDetails = [];
        await this.lookupservice
            .searchTransactionlDetails(this.patient.patient_guid, this.query)
            .then((details) => {
                if (details.success) {
                    this.TranactionDetails = details.data.transaction_data.rows;
                    this.total_records = details.data.transaction_data.count;
                } else {
                    this.transactionerror = details;
                }
            })
            .catch((transactionerror) => {
                this.TranactionDetails = [];
                this.transactionerror = transactionerror;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: this.transactionerror?.error.message
                });

            });
        this.loading1 = false;
    }

    open3() {
        this.loading = true;
        this.ConsltationDetails = [];
        this.lookupservice
            .searchConsultationDetails(this.patient.patient_guid)
            .then((details) => {
                if (details.success) {
                    this.ConsltationDetails = details.data.consultation_data;
                    // this.modifyConsultationObject(this.ConsltationDetails);
                    this.loading = false;
                } else {
                    this.consultaionerror = details;
                    this.loading = false;
                }
            })
            .catch((consultaionerror) => {
                this.ConsltationDetails = [];
                this.consultaionerror = consultaionerror;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: consultaionerror?.error.message
                });
                this.loading = false;
            });
    }

    modifyConsultationObject(ConsultObject) {
        var num = 0;
        var num1 = 0;
        var count = 0;
        var str = "";
        var strtemp;
        for (num = 0; num < ConsultObject.length; num++) {

            const temp = ConsultObject[num].p_consultation_appointment;
            str = "";
            strtemp = "";
            for (num1 = 0; num1 < temp.length; num1++) {
                strtemp = temp[num1].d_specialty_type.specialty_name + ","
                str = strtemp + str;
                count++;
            }

            count++;
        }
    }
    handleEdit() {
        this.disabled = false;
    }

    handleSave() {

        this.patient1.primary_contact_number = this.patient1.primary_contact_number.length > 0 ? "+" + this.patient1.phone_code + this.patient1.primary_contact_number : null;
        this.patient1.secondary_contact_number = this.patient1.secondary_contact_number.length > 0 ? "+" + this.patient1.phone_code + this.patient1.secondary_contact_number : null;

        const body = this.patient1;
        const patient_guid = this.patient.patient_guid;
        if (this.patient1.state_name != null) {
            this.lookupservice
                .savePersonalDetails(body, patient_guid)
                .then((resp) => {
                    if (resp == true) {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Saved Data',
                            detail: 'Updated Data In Database'
                        });
                    }
                })
                .catch((e) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: e.error.message
                    });
                });
            this.disabled = true;
        } else {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'State Does Not Belong To Country'
            });
        }
    }

    async setState(countrycode) {
        let code: number = countrycode;
        await this.CountryService.getStates(code)
            .toPromise()
            .then((details) => {
                if (details.length != 0) {
                    this.patient1.country_id = '' + code;
                    this.states = details;
                    this.patient1.phone_code =
                        details[0].country.phone_code + '';
                }
            })
            .catch((e) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: e.error
                });
            });
    }

    async getCountries() {
        await this.CountryService.getCountries(this.provider_id)
            .toPromise()
            .then((countries) => (this.countries = countries));
    }

    onCountryChange(value) {
        this.patient1.state_name = null;
        this.selectedState = null;
        const code: number = value.id;
        this.setState(code);
        this.patient1['country_id'] = '' + value.id;
        this.patient1['country_name'] = value.country_name;
    }

    onStateChange(value) {
        this.patient1['state_id'] = '' + value.id;
        this.patient1['state_name'] = value.state_name;
    }

    dosomething(value: any, input: string | number) {
        this.patient1[input] = value;
    }

    async getConsultationsHistoryData(id) {
        this.history_posting = true;
        const user_guid = sessionStorage.getItem('userid');
        let history_query_data: CosnultationHistoryDataQuery = {
            patient_guid: this.patient.patient_guid,
            user_guid: user_guid,
            consultation_id: id
        };
        this.appointmentService
            .getCosnultationHistory(history_query_data)
            .toPromise()
            .then((result) => {
                this.history_response = result;
                if (result.success) {
                    this.history = result.data;
                    this.historyDialog = true;
                }
                /* else if (!this.history_response.success) {
      //this.history_error = result.error;
  } */
                this.history_posting = false;
            })
            .catch((e) => {
                this.history_posting = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: e.error.message
                });
            });
    }

    prev() {
        this.router.navigate(['/' + this.slug + '/doctor/lookup-list-p']);
    }
}
